var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unpack-center"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.detailData.title))])]),_c('div',{staticClass:"apart-list",domProps:{"innerHTML":_vm._s(_vm.detailData.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }